import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

import useNotificationDropdownOptions from "../hooks/useNotificationDropdownOptions";

export default function NotificationDropdown({ todo }) {
	const options = useNotificationDropdownOptions(todo);

	return (
		<DropdownMenu
			iconStyle={{ display: "flex", alignItems: "center", justifyContent: "center", height: 50, width: 30 }}
			options={options}
			style={{
				position: "absolute",
				top: 0,
				right: 0,
				cursor: "pointer",
			}}
		/>
	);
}
